import { render, staticRenderFns } from "./VendorLocationList.vue?vue&type=template&id=471d7cff"
import script from "./VendorLocationList.vue?vue&type=script&lang=js"
export * from "./VendorLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports